import { useEffect } from 'react'

import LandingNav from './LandingNav'
import Footer from './Footer'
import Hero from './sections/Hero'
import Problem from './sections/Problem'
import Engine from './sections/Engine'
import Capabilities from './sections/Capabilities'
import Regulations from './sections/Regulations'
import Platform from './sections/Platform'
import Results from './sections/Results'
import Team from './sections/Team'
import Trust from './sections/Trust'
import Demo from './sections/Demo'
import './landing.css'

/**
 * Ported from the Claude Design canvas ("Overmatch - New Approach").
 * Tan page with three dark cuts — the acquisition engine, the regulation
 * panel, and the closing CTA — and one lifted near-white band carrying
 * results and the team.
 *
 * Static by design: no scroll animation, no motion library. The nav's
 * mobile collapse and the card hover states are additions to the canvas.
 */
export default function LandingPage() {
  // Arriving from another route (say /press-releases → /#engine), the page
  // loads with a fragment but the browser looked for it before React had
  // rendered the section, so scroll to it once it exists.
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.slice(1))
    if (id) document.getElementById(id)?.scrollIntoView({ behavior: 'instant' })
  }, [])

  return (
    <div className="lp">
      <LandingNav />
      <main id="top">
        <Hero />
        <Problem />
        <Engine />
        <Capabilities />
        <Regulations />
        <Platform />
        <Results />
        <Team />
        <Trust />
        <Demo />
      </main>
      <Footer />
    </div>
  )
}
